import {
  Alert,
  Box,
  Button,
  Container,
  FormField,
  Header,
  SpaceBetween,
  Spinner,
  Textarea,
} from '@amzn/awsui-components-react-v3';
import moment from 'moment';
import React, { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ReceiveExceptionNote,
  ReceiveExceptionStatus,
} from '../../../../services/receive-exception/types';
import { ReceiveExceptionView } from '../types';
import './style.css';
import useExceptionNotes from './useExceptionNotes';

export default function ExceptionNotes({ data }: { data: ReceiveExceptionView }): ReactElement {
  const { t } = useTranslation();
  const {
    noteListRef,
    noteListContainerRef,
    newNote,
    setNewNote,
    listNotesLoading,
    listNotesError,
    notes,
    handleCreateNote,
    creatingNote,
    createNoteError,
    handleScroll,
  } = useExceptionNotes(data);

  return (
    <Container
      header={
        <Header variant="h2" description="">
          {t('Comment History')}
        </Header>
      }>
      <div>
        {notes && (
          <div className="comment-history" ref={noteListContainerRef} onScroll={handleScroll}>
            <div ref={noteListRef}>
              {listNotesLoading && (
                <Box textAlign="center" padding={{ top: 'l', bottom: 'l' }}>
                  <Spinner size="normal" />
                </Box>
              )}
              {(notes as ReceiveExceptionNote[]).map((note) => (
                <Comment data={note} key={note.id} />
              ))}
            </div>
          </div>
        )}
        {listNotesError && <Alert type="error">{listNotesError}</Alert>}
        {data.status !== ReceiveExceptionStatus.CANCELLED && (
          <SpaceBetween direction="vertical" size="s">
            <FormField stretch>
              <Textarea
                data-test-id="input-new-note"
                value={newNote}
                onChange={(event) => setNewNote(event.detail.value)}
                disabled={creatingNote}
                placeholder={t('Write any notes here')}
              />
            </FormField>
            <Button
              data-test-id="button-submit-note"
              disabled={!newNote}
              loading={creatingNote}
              onClick={handleCreateNote}>
              {t('Submit Comment')}
            </Button>
            {createNoteError && <Alert type="error">{createNoteError}</Alert>}
          </SpaceBetween>
        )}
      </div>
    </Container>
  );
}

export function Comment({ data }: { data: ReceiveExceptionNote }): ReactElement {
  return (
    <div className="comment-box" key={`${data.id}`}>
      <div>{data.note}</div>
      <div>
        <small>
          <span>@{data.createdBy.contact}</span>
        </small>{' '}
        -{' '}
        <small title={moment(data.createdAt).format('DD MMM YYYY, hh:mm A')}>
          {moment(data.createdAt).fromNow()}
        </small>
      </div>
    </div>
  );
}
